import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";
class DriverService {

    async driverGet(page, perpage, search) {
        const pageParam = `page=${page}&perPage=${perpage}`
        let params = search ? pageParam + `&search=${search}` : pageParam;
        const response = await ajaxService.get(`/drivers?${params}`)
        if (response?.success ?? false) {
            return response;
        } else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }

    async view(id) {
        const response = await ajaxService.get(`/drivers/${id}`);
        if (response?.success ?? false) {
            return response;
        } else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }

    async add(data) {
        const response = await ajaxService.post('/drivers', data)
        if (response?.success ?? false) {
            return response;
        } else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }

    async update(id, data) {
        const response = await ajaxService.put(`/drivers/`, id, data)
        if (response?.success ?? false) {
            return response;
        } else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }

    async delete(id) {
        const response = await ajaxService.delete(`/drivers/`, id)
        if (response?.success ?? false) {
            return response;
        } else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }
}

const driverService = new DriverService()
export default driverService